import { TypeChecker } from '@attain-apps/type-guards'

import { Action } from './action'

/**
 * TODO: explain
 *
 * When {@link source} is a `string`, we recommend making it as easy to
 * recognize as possible. Usually, this is a short, very readable sentence
 * describing the event that has occurred, but with each word capitalized
 * to make it look cleaner. However, sometimes, it might be more helpful
 * to use the exact name of the feature, class, function, etc. so that it
 * is easier to search for in the codebase.
 *
 * @see {@link Producer}
 * @example
 * from(someAction).create(...)
 * from('Table Add Button Was Clicked').bulkCreate(...)
 * from('GraphQL API Request Timed Out').create(...)
 * from('MyComponent.ngOnInit').bulkCreate(...)
 */
// NOTE: need TState to be `any` since it is invariant, which means an Action
// can only be a Source if its TState exactly matches the TState here, and only
// `any` can "exactly" match everything
export type Source = Action<any> | string
export namespace Source {
  export const isSource: TypeChecker<Source> = TypeChecker.Factory.union(
    TypeChecker.isString,
    Action.isAction,
  )
}
